class BaseResponse {
    default={
        responseCode: null,
        responseMessage: null,
    }
}
export default BaseResponse